import {
  addHtmlElementEventListener,
  getHtmlElement,
  renderWebComponent,
  string2obj
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import paypalStyles from '../../styles/paypal.css';
import { EventBusComponent } from "../EventBusComponent";
import { loadScript } from "@paypal/paypal-js";
import I18n from "i18n-js";

let paypal;
let amount;
let locale;
let currency;
let submissionList;
let paymentMethod;
let confirmHandler;
let eventBus = EventBusComponent.getInstance();

export class PaypalButtonComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    amount = this.props.amount;
    locale = this.props.locale;
    currency = this.props.currency;
    submissionList = this.props.submissionList;
    paymentMethod = !this.props.disablePayment ? 'paypal' : null;
    confirmHandler = this.handleConfirmSubmissionList;
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }


  // Funzione che gestisce la conferma finale della submission list
  // una volta che il pagamento tramite paypal è andato a buon fine
  handleConfirmSubmissionList(paypalTransactionId) {
    const url = `/submission_lists/${submissionList.id}`;

    fetch(url + ".json", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ state: 'confirmed', payment_method: paymentMethod, paypal_transaction_id: paypalTransactionId }),
    })
      .then((response) => {
        if (!response.ok) {
          if ([503].includes(response.status))
            return response.json().then(data => {
              throw { status: response.status, data: data };
            });
          else
            throw Error("An error occour during saving data on the database");
        }
        else
          return response.json();
      })
      .then((submissionList) => {
        eventBus.publish('closed-submission-list', submissionList);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        if (error.status === 503) {
          const errorMessage = I18n.t('js.editSubmissionListPage.webComponent.validation.text9_1').replaceAll(':start_day', this.props.submissionList.home_pick_up_time_range_italian_format[0]);
          eventBus.publish('render-modal', {error: true, errorMessage: errorMessage});

          if (error.data)
            eventBus.publish('updated-submission-list-state', error.data);
        }
        else
          eventBus.publish('render-modal', {error: true});
      });
  }


  // Renderizzo i bottoni di pagamento paypal sull'interfaccia grafica
  async connectedCallback() {
    if (this.props.disablePayment) {
      addHtmlElementEventListener(this.shadowRoot, 'confirm_btn', 'click', () => this.handleConfirmSubmissionList(null))
    } else {
      try {
        paypal = await loadScript(
          {
            "client-id": submissionList.grader_company.paypal_client_id,
            "currency": currency,
            "locale": locale
          });
      } catch (error) {
        console.error("failed to load the PayPal JS SDK script", error);
      }

      if (paypal) {
        try {
          await paypal.Buttons({
            // Styling dei bottoni di pagamento paypal
            style: {
              layout: 'vertical',
              color: "blue",
              shape: "pill",
              label: "pay",
              tagline: false,
              height: 50
            },

            // Funzione che crea l'ordine di pagamento tramite paypal
            createOrder: function(data, actions) {
              return actions.order.create({
                purchase_units: [{
                  amount: {
                    value: amount
                  },
                  description: `${I18n.t('js.editSubmissionListPage.webComponent.draft.payment.causal')}${submissionList.number}`
                }]
              });
            },

            // Funzione che gestice l'avvenuto pagamento tramite paypal
            onApprove: function(data, actions) {
              return actions.order.capture().then(function(details) {
                confirmHandler(details.id);
              });
            }
          }).render(getHtmlElement(this.shadowRoot, 'paypal-button-container'));
        } catch (error) {
          console.error("failed to render the PayPal Buttons", error);
        }
      }
    }
  }



  render() {
    const html = `     
      ${
        !this.props.disablePayment ?
          `<div id="paypal-button-container" class="paypal-btn-container"></div>`
        :
          `<button
            id="confirm_btn"
            class="btn-standard bg-aig-gradient color-white br-50px btn-standard-resized mb-1 px-3 pb-1 w-100 min-h-50px-imp min-w-200px"
            type="button"
          >
            <b>
                ${I18n.t('js.common.button.confirm').toUpperCase()}
            </b>
          </button>`
      }`

    renderWebComponent(html, this.shadowRoot, [commonStyles, paypalStyles]);
  }
}

window.customElements.define("paypal-button-component", PaypalButtonComponent);